import React, { useState } from 'react';
import CollapsiblePanel from '../../../../formInputsV2/CollapsiblePanel';
import { safeCapitalizeWords } from '../../../../constants';
import { Card, AlwaysOpenAtDesktop } from './shared.styles';
import {
  EmptyState,
  TotalBar,
  TotalLabel,
  TotalAmount,
  ProcediCta,
  QuoteList,
  SectionLabel,
  QuoteLineItem,
  CompanyName,
  QuoteTypeTag,
  Amount,
  EstimatedCommission,
} from './QuoteCostSummaryCard.styles';

// Commercial diverges from the shared QuoteCostSummaryCard in two real
// ways: an "(RCO Inclusa)" badge appears next to the top line's tag for
// company_id 1001, and a second, separately-headed section lists
// commercialExtraQuoteTypes ("Garanzie operanti a livello di ubicazione")
// that no other product has — so it gets its own component.
function CommercialQuoteCostSummaryCard({
  processingQuote,
  quoteTypes,
  riskQuotations,
  commercialExtraQuoteTypes,
  hasExtraRiskQuotes,
  getTotal,
  onProcedi,
  est_provvigioni,
}) {
  const [detailsOpen, setDetailsOpen] = useState(false);

  if (processingQuote === null) {
    return (
      <Card>
        <EmptyState>Seleziona Le Quotazioni Che Vuoi Aquistare</EmptyState>
      </Card>
    );
  }

  const companyName = processingQuote.company !== null && processingQuote.company.name;

  return (
    <Card>
      <TotalBar>
        <div>
          <TotalLabel>Totale</TotalLabel>
          <TotalAmount>
            {getTotal()}
            {' '}
            €
          </TotalAmount>
          {(est_provvigioni != null && est_provvigioni !== '' && !Number.isNaN(parseFloat(est_provvigioni))) && (
            <EstimatedCommission>
              Stima Provvigioni:
              {' '}
              {parseFloat(est_provvigioni).toFixed(2)}
              {' '}
              €
            </EstimatedCommission>
          )}
        </div>
        {onProcedi && (
          <ProcediCta type="button" onClick={onProcedi}>
            Procedi
          </ProcediCta>
        )}
      </TotalBar>

      <AlwaysOpenAtDesktop>
        <CollapsiblePanel
          open={detailsOpen}
          onToggle={() => setDetailsOpen((open) => !open)}
          instructionText=""
          openLabel="Nascondi Dettaglio"
          closedLabel="Vedi Dettaglio Quotazioni"
        >
          <QuoteList>
            <QuoteLineItem>
              <CompanyName>
                {companyName}
                {' '}
                <QuoteTypeTag>
                  (
                  {
                    safeCapitalizeWords(quoteTypes.find(
                      (item) => item.id === processingQuote.quote_type,
                    ).name)
                  }
                  {processingQuote.company_id == 1001 && (
                    <>
                      {' '}
                      <small>(RCO Inclusa)</small>
                    </>
                  )}
                  )
                </QuoteTypeTag>
              </CompanyName>
              <Amount>
                {parseFloat(processingQuote.amount ? processingQuote.amount : 0).toFixed(2)}
                {' '}
                €
              </Amount>
            </QuoteLineItem>

            {quoteTypes
              .filter((t) => t.id !== 'res_civile')
              .map((type) => (
                <React.Fragment key={type.id}>
                  {riskQuotations && riskQuotations[type.id]
                    ? riskQuotations[type.id].map((quote, i) => (
                      <QuoteLineItem key={i}>
                        <CompanyName>
                          {quote.company !== null
                            ? quote.company.name
                            : quote.preventivas_company.company_name}
                          {' '}
                          <QuoteTypeTag>
                            (
                            {
                              safeCapitalizeWords(quoteTypes.find(
                                (item) => item.id === quote.quote_type,
                              ).name)
                            }
                            )
                          </QuoteTypeTag>
                        </CompanyName>
                        <Amount>
                          {parseFloat(quote.amount).toFixed(2)}
                          {' '}
                          €
                        </Amount>
                      </QuoteLineItem>
                    ))
                    : null}
                </React.Fragment>
              ))}

            {hasExtraRiskQuotes && (
              <>
                <SectionLabel>Garanzie Operanti a Livello di Ubicazione</SectionLabel>
                {commercialExtraQuoteTypes.map((type) => (
                  <React.Fragment key={type.id}>
                    {riskQuotations && riskQuotations[type.id]
                      ? riskQuotations[type.id].map((quote, i) => (
                        <QuoteLineItem key={i}>
                          <CompanyName>
                            {quote.company !== null
                              ? quote.company.name
                              : quote.preventivas_company.company_name}
                            {' '}
                            <QuoteTypeTag>
                              (
                              {
                                commercialExtraQuoteTypes.find(
                                  (item) => item.id === quote.quote_type,
                                ).name
                              }
                              )
                            </QuoteTypeTag>
                          </CompanyName>
                          <Amount>
                            {parseFloat(quote.amount).toFixed(2)}
                            {' '}
                            €
                          </Amount>
                        </QuoteLineItem>
                      ))
                      : null}
                  </React.Fragment>
                ))}
              </>
            )}
          </QuoteList>
        </CollapsiblePanel>
      </AlwaysOpenAtDesktop>
    </Card>
  );
}

export default CommercialQuoteCostSummaryCard;
